/* Gearloop cart drawer helpers (PREMIUM REDESIGN). Loaded by snippets/cart-drawer.liquid.
   - <gl-cart-recs>: loads product recommendations for the newest cart items through the Section Rendering API
     (sections/gl-cart-recs.liquid), drops products already in the cart and variants blocked by gl-brand.js,
     shows up to 3 with a one-tap Add button.
   - Add: POST /cart/add with the drawer sections, then re-renders the drawer (same path as the theme's own forms).
   - Light motion when the drawer opens. No timers, countdowns, discounts or stock claims. */
(function () {
  'use strict';
  var MAX = 3;
  var cache = {};
  var lastHTML = {};

  function allowed(id) {
    try { return !(window.GLGUARD && window.GLGUARD.isB(id)); } catch (e) { return true; }
  }
  function root() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function load(url, pid, intent) {
    var key = url + '|' + pid + '|' + intent;
    if (!cache[key]) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      cache[key] = fetch(url + sep + 'product_id=' + encodeURIComponent(pid) + '&limit=10&intent=' + intent + '&section_id=gl-cart-recs')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          var d = new DOMParser().parseFromString(t, 'text/html');
          return Array.prototype.slice.call(d.querySelectorAll('.gl-rec'));
        })
        .catch(function () { delete cache[key]; return []; });
    }
    return cache[key];
  }

  /* keep only variants that can really be bought here; returns false if nothing is left */
  function clean(card) {
    var sel = card.querySelector('.gl-rec__select');
    var btn = card.querySelector('.gl-rec__add');
    if (!btn) return false;
    if (sel) {
      Array.prototype.slice.call(sel.options).forEach(function (o) { if (!allowed(o.value)) o.parentNode.removeChild(o); });
      if (!sel.options.length) return false;
      sel.selectedIndex = 0;
      btn.dataset.variantId = sel.value;
      var price = card.querySelector('.gl-rec__price');
      if (price && sel.options[0].dataset.price) price.textContent = sel.options[0].dataset.price;
      if (sel.options.length === 1) {
        var lab = card.querySelector('label[for="' + sel.id + '"]');
        if (lab) lab.parentNode.removeChild(lab);
        sel.parentNode.removeChild(sel);
      }
      return true;
    }
    return !!btn.dataset.variantId && allowed(btn.dataset.variantId);
  }

  class GLCartRecs extends HTMLElement {
    connectedCallback() { start(this); }
  }

  function start(self) {
    if (self._started) return;
    self._started = true;
    var url = self.dataset.url || '/recommendations/products';
    var pids = (self.dataset.products || '').split(',').filter(Boolean).slice(0, 2);
    var inCart = ',' + (self.dataset.inCart || '');
    var sig = pids.join(',') + '#' + inCart;
    var list = self.querySelector('.gl-recs__list');
    if (!pids.length || !list) return;
    if (lastHTML[sig]) { list.innerHTML = lastHTML[sig]; self.hidden = false; return; }

    var jobs = [];
    pids.forEach(function (pid) { jobs.push([pid, 'complementary'], [pid, 'related']); });
    var seen = {}, picked = [];
    (function next(i) {
      if (picked.length >= MAX || i >= jobs.length) return done();
      load(url, jobs[i][0], jobs[i][1]).then(function (cards) {
        cards.forEach(function (c) {
          if (picked.length >= MAX) return;
          var id = c.getAttribute('data-product-id');
          if (!id || seen[id] || inCart.indexOf(',' + id + ',') > -1) return;
          var copy = c.cloneNode(true);
          if (!clean(copy)) return;
          seen[id] = 1;
          picked.push(copy);
        });
        next(i + 1);
      });
    })(0);

    function done() {
      if (!picked.length || !self.isConnected) return;
      list.innerHTML = '';
      picked.forEach(function (c) { list.appendChild(c); });
      lastHTML[sig] = list.innerHTML;
      self.hidden = false;
      self.classList.add('gl-recs--in');
    }
  }
  if (!customElements.get('gl-cart-recs')) customElements.define('gl-cart-recs', GLCartRecs);

  /* variant select keeps button + price in sync */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.classList || !sel.classList.contains('gl-rec__select')) return;
    var card = sel.closest('.gl-rec');
    var btn = card && card.querySelector('.gl-rec__add');
    if (btn) btn.dataset.variantId = sel.value;
    var o = sel.options[sel.selectedIndex];
    var price = card && card.querySelector('.gl-rec__price');
    if (price && o && o.dataset.price) price.textContent = o.dataset.price;
  });

  function fail(card, btn, msg) {
    btn.classList.remove('is-loading');
    btn.removeAttribute('disabled');
    var p = card.querySelector('.gl-rec__error');
    var holder = card.closest('gl-cart-recs');
    if (p) { p.textContent = msg || (holder && holder.dataset.error) || 'Error'; p.hidden = false; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gl-rec__add');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.gl-rec');
    var sel = card.querySelector('.gl-rec__select');
    var id = sel ? sel.value : btn.dataset.variantId;
    var holder = card.closest('gl-cart-recs');
    if (!id || !allowed(id)) { fail(card, btn); return; }
    if (btn.classList.contains('is-loading')) return;
    var err = card.querySelector('.gl-rec__error');
    if (err) err.hidden = true;
    btn.classList.add('is-loading');
    btn.setAttribute('disabled', 'disabled');

    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try { sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (x) { sections = ['cart-drawer', 'cart-icon-bubble']; }

    fetch(root(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { fail(card, btn, res.j && (res.j.description || res.j.message)); return; }
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var label = btn.querySelector('.gl-rec__add-label');
        if (label && holder && holder.dataset.added) label.textContent = holder.dataset.added;
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
          setTimeout(function () {
            var input = document.querySelector('#CartDrawer .quantity__input[data-quantity-variant-id="' + id + '"]');
            var row = input && input.closest('.cart-item');
            if (row) row.classList.add('gl-flash');
          }, 60);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        try {
          if (document.querySelector('cart-items') && typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gl-cart-recs', cartData: res.j, variantId: id });
          }
        } catch (x) {}
      })
      .catch(function () { fail(card, btn); });
  });

  /* light open animation; kept short and skipped for reduced motion via CSS */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || C.prototype._glWrapped) return;
      var open = C.prototype.open;
      C.prototype.open = function () {
        var el = this;
        el.classList.add('gl-anim');
        clearTimeout(el._glT);
        el._glT = setTimeout(function () { el.classList.remove('gl-anim'); }, 900);
        return open.apply(this, arguments);
      };
      C.prototype._glWrapped = true;
    });
  }

  /* the old fixed-product upsell snippets called these; keep harmless stubs in case any template still renders them */
  if (typeof window.primaryUpsellVariantChange !== 'function') window.primaryUpsellVariantChange = function () {};
  if (typeof window.secondaryUpsellVariantChange !== 'function') window.secondaryUpsellVariantChange = function () {};
})();
